import {useEffect} from "react";
import useNetwork from "./useNetwork";

export const useNetworkStatusChange = (onChange: (online: boolean) => void) => {
    const {online} = useNetwork();
    useEffect(() => {
        onChange(online);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [online])
}